"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIllustration = _interopRequireDefault(require("../withIllustration"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IllustrationLowHouse = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 80 60",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            fill: "#FFFFFF",
            x: "0",
            y: "4",
            width: "56",
            height: "56"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            fill: "#C3D0D8",
            x: "56",
            y: "4",
            width: "24",
            height: "56"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            fill: "#091E43",
            x: "0",
            y: "0",
            width: "56",
            height: "4"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            fill: "#031432",
            x: "56",
            y: "0",
            width: "24",
            height: "4"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            fill: "#C3D0D8",
            x: "8",
            y: "44",
            width: "8",
            height: "8"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            fill: "#C3D0D8",
            x: "8",
            y: "28",
            width: "8",
            height: "8"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            fill: "#C3D0D8",
            x: "24",
            y: "28",
            width: "8",
            height: "8"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            fill: "#C3D0D8",
            x: "8",
            y: "12",
            width: "8",
            height: "8"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            fill: "#C3D0D8",
            x: "24",
            y: "12",
            width: "8",
            height: "8"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            fill: "#091E43",
            x: "24",
            y: "44",
            width: "8",
            height: "16"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            fill: "#C3D0D8",
            x: "40",
            y: "44",
            width: "8",
            height: "8"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            fill: "#091E43",
            x: "64",
            y: "44",
            width: "8",
            height: "8"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            fill: "#C3D0D8",
            x: "40",
            y: "28",
            width: "8",
            height: "8"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            fill: "#091E43",
            x: "64",
            y: "28",
            width: "8",
            height: "8"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            fill: "#C3D0D8",
            x: "40",
            y: "12",
            width: "8",
            height: "8"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            fill: "#091E43",
            x: "64",
            y: "12",
            width: "8",
            height: "8"
          })]
        })
      })
    })
  });
};
var _default = exports.default = (0, _withIllustration.default)('IllustrationLowHouse')(IllustrationLowHouse);